import * as React from "react";
const SvgPlayArrowFill = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M320-200v-560l440 280-440 280Z" }));
export default SvgPlayArrowFill;
